const config = {
    env: 'production',
    apiUrl: "https://foodtech-api.onap.uk/admin/v1",
    // apiUrl: "http://15.206.68.199:6005/admin/v1", // direct server (no SSL)
    // apiUrl: "https://fh6j56pb-5556.inc1.devtunnels.ms/admin/v1", // dev tunnel — never commit
}

export default config;